export type Period = "today" | "week" | "month" | "firstHalf" | "secondHalf" | "all" | "custom";

export function periodRange(period: Exclude<Period, "custom">, today: string) {
    if (period === "firstHalf" || period === "secondHalf") {
        const year = Number(today.slice(0, 4));
        const secondHalf = period === "secondHalf";
        const seasonYear = secondHalf && today < `${year}-07-01` ? year - 1 : year;
        const from = `${seasonYear}-${secondHalf ? "07-01" : "01-01"}`;
        const end = `${seasonYear}-${secondHalf ? "12-31" : "06-30"}`;
        return { from, to: end < today ? end : today };
    }
    const days = period === "week" ? 6 : period === "month" ? 29 : 0;
    return {
        from: new Date(Date.parse(today) - days * 86400000).toISOString().slice(0, 10),
        to: today,
    };
}
